angular.module('pitch.app')

.factory('TrackInfoModal', function(config, Modal) {
    return {
        open: function(params, data) {
            Modal.create(
                config.templateRoot + '/templates/modals/track-info',
                params,
                data
            );
        }
    };
})

.factory('TrackInfoSimpleModal', function(config, Modal) {
    return {
        open: function(params, data) {
            Modal.create(
                config.templateRoot + '/templates/modals/track-info-simple',
                params,
                data
            );
        }
    };
})
;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/TrackInfoModal.js